import { render, staticRenderFns } from "./GenerateAutomateTask.vue?vue&type=template&id=874d8798&scoped=true&"
import script from "./GenerateAutomateTask.vue?vue&type=script&lang=ts&"
export * from "./GenerateAutomateTask.vue?vue&type=script&lang=ts&"
import style0 from "./GenerateAutomateTask.vue?vue&type=style&index=0&id=874d8798&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874d8798",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
